module.exports = __webpack_public_path__ + "media/images/partner/psychiatrie-baselland-c4c089f366119c3805e953b82698abc1.png";